import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Live(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.85 3.61a.508.508 0 00.293-.651.498.498 0 00-.643-.297A9.991 9.991 0 005 4.918c-1.85 1.837-3 4.398-3 7.23 0 4.345 2.704 8.049 6.5 9.485a.498.498 0 00.643-.297.508.508 0 00-.293-.651C5.432 19.392 3 16.057 3 12.147a9.137 9.137 0 012.7-6.506 8.993 8.993 0 013.15-2.03zM15.5 2.662a.498.498 0 00-.643.297.508.508 0 00.293.651C18.568 4.903 21 8.238 21 12.147c0 3.91-2.432 7.245-5.85 8.538a.508.508 0 00-.293.65.498.498 0 00.643.298c3.796-1.436 6.5-5.14 6.5-9.486 0-4.345-2.704-8.05-6.5-9.485z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.46 6.726a.498.498 0 01.65-.282c2.255.91 3.89 2.922 3.89 5.703 0 2.78-1.632 4.823-3.89 5.734a.498.498 0 01-.65-.282.508.508 0 01.28-.658c1.919-.774 3.26-2.472 3.26-4.794 0-2.317-1.338-3.987-3.26-4.763a.508.508 0 01-.28-.658zM10.261 7.384a.508.508 0 00.278-.659.498.498 0 00-.65-.28C7.664 7.348 6 9.29 6 12.146c0 2.78 1.632 4.823 3.89 5.734a.498.498 0 00.65-.282.508.508 0 00-.28-.658C8.341 16.167 7 14.47 7 12.147c0-2.382 1.356-3.988 3.261-4.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 12.147c0 1.118-.895 2.025-2 2.025s-2-.907-2-2.025c0-1.118.895-2.024 2-2.024s2 .906 2 2.024zm-1 0c0 .56-.448 1.013-1 1.013s-1-.454-1-1.013c0-.559.448-1.012 1-1.012s1 .453 1 1.012z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Live);
export default ForwardRef;